import { htmlSafe } from '@ember/template';
import { helper as buildHelper } from '@ember/component/helper';
import { gifUrlToGif } from 'mewe/utils/gif-utils';

export default buildHelper(function (values) {
  return htmlSafe(gifUrlToGif(values && values[0]));
});
